import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // This setting is used to send credentials (such as cookies,
    //  HTTP authentication, or client-side SSL certificates) with cross-origin requests.
    const modifiedRequest = request.clone({
      withCredentials: true,
    });

    // Pass the modified request to the next handler
    return next.handle(modifiedRequest);
  }
}
